import type { Job } from '@/domains/jobs/components/JobCard';
import { parseISO } from 'date-fns';

/**
 * Detect scheduling conflicts (overlapping jobs on the same day for the same
 * resource). Operates on the FE Job shape because conflicts use job-level
 * start/end times that the BE capacity endpoint doesn't expose.
 */
export function detectSchedulingConflicts(jobs: Job[]): Map<string, Job[][]> {
  const conflictMap = new Map<string, Job[][]>();

  const jobsByDate = new Map<string, Job[]>();
  jobs.forEach((job) => {
    if (!job.scheduledDate || !job.startTime || !job.endTime) return;
    if (!jobsByDate.has(job.scheduledDate)) {
      jobsByDate.set(job.scheduledDate, []);
    }
    jobsByDate.get(job.scheduledDate)!.push(job);
  });

  jobsByDate.forEach((dayJobs, dateStr) => {
    const conflicts: Job[][] = [];
    for (let i = 0; i < dayJobs.length; i++) {
      for (let j = i + 1; j < dayJobs.length; j++) {
        const job1 = dayJobs[i];
        const job2 = dayJobs[j];
        if (!job1.startTime || !job1.endTime || !job2.startTime || !job2.endTime) continue;
        const start1 = parseISO(job1.startTime);
        const end1 = parseISO(job1.endTime);
        const start2 = parseISO(job2.startTime);
        const end2 = parseISO(job2.endTime);
        if (start1 < end2 && end1 > start2) {
          conflicts.push([job1, job2]);
        }
      }
    }
    if (conflicts.length > 0) conflictMap.set(dateStr, conflicts);
  });

  return conflictMap;
}
